import React from 'react';
import Icon from '../../../components/AppIcon';

const OrderConfirmationCard = ({
  orderNumber,
  totalAmount,
  paymentMethod,
  stripeTransactionId,
  transactionTimestamp,
  orderDate
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card rounded-xl shadow-warm border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <Icon name="FileText" size={24} className="text-primary" />
        <h2 className="font-heading font-bold text-xl text-foreground">
          Order Confirmation
        </h2>
      </div>

      <div className="space-y-4">
        {/* Order Number */}
        <div className="flex items-center justify-between py-3 border-b border-border">
          <span className="text-muted-foreground font-body">Order Number</span>
          <span className="font-mono font-semibold text-foreground">{orderNumber}</span>
        </div>

        {/* Order Date */}
        <div className="flex items-center justify-between py-3 border-b border-border">
          <span className="text-muted-foreground font-body">Order Date</span>
          <span className="font-body text-foreground">{formatDate(orderDate)}</span>
        </div>

        {/* Total Amount */}
        <div className="flex items-center justify-between py-3 border-b border-border">
          <span className="text-muted-foreground font-body">Total Amount</span>
          <span className="font-heading font-bold text-lg text-primary">
            ${totalAmount?.toFixed(2)}
          </span>
        </div>

        {/* Payment Method */}
        <div className="flex items-center justify-between py-3 border-b border-border">
          <span className="text-muted-foreground font-body">Payment Method</span>
          <div className="flex items-center space-x-2">
            <Icon name="CreditCard" size={16} className="text-muted-foreground" />
            <span className="font-body text-foreground">{paymentMethod}</span>
          </div>
        </div>

        {/* Stripe Transaction ID */}
        <div className="py-3">
          <div className="flex items-start justify-between">
            <span className="text-muted-foreground font-body">Stripe Transaction ID</span>
            <span className="font-mono text-sm text-foreground break-all text-right max-w-[60%]">
              {stripeTransactionId}
            </span>
          </div>
          <p className="text-xs text-muted-foreground mt-2">
            Transaction completed at {formatDate(transactionTimestamp)}
          </p>
        </div>

        {/* Payment Status Badge */}
        <div className="pt-4">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-success/10 rounded-lg">
            <Icon name="CheckCircle" size={16} className="text-success" />
            <span className="font-body font-medium text-success">Payment Successful</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationCard;